import { CustomPageValidatorFn } from '../../types/custom-page-validator';
import { customPageValidation as whoWhatWasInjured } from './hvad-er-skadet';
import { customPageValidation as whatIsDamaged } from './what-is-damaged';
import { customPageValidation as informationAboutCounterpart } from './informationer-om-modpart';
import { customPageValidation as informationAboutPassengers } from './oplysninger-om-passagerer';
import { customPageValidation as aboutOwner } from './om-ejeren';
import { customPageValidation as aboutCounterPart } from './om-modparten';
import { customPageValidation as stormPages } from './storm-pages';
import { customPageValidation as otherStuffBuildingAnimalInfo } from './andres-ting-bygning-dyr-oplysninger';
import { customPageValidation as stormBygningLandbrug } from './storm-bygning-landbrug';
import { customPageValidation as counterPartBusiness } from './erhverv-modpart';

export const CustomPageValidationMap: Record<string, CustomPageValidatorFn> = {
    'hvad-er-skadet': whoWhatWasInjured,
    'select-damage': whatIsDamaged,
    'informationer-om-modpart': informationAboutCounterpart,
    'oplysninger-om-passagerer': informationAboutPassengers,
    'om-modparten': aboutCounterPart,
    'om-ejeren': aboutOwner,
    'storm-pages': stormPages,
    'andres-ting-bygning-dyr-oplysninger': otherStuffBuildingAnimalInfo,
    'erhverv-modpart': counterPartBusiness,
    'storm-bygning-landbrug': stormBygningLandbrug
};
